import React from 'react';
import styles from './styles.module.scss';
import { Box } from '@mui/material';

type ComponentTypes = {
  children: any;
  icon?: React.ReactElement;
  onClick?: () => void;
  variant: 'active' | 'activeRounded' | 'in_active' | 'danger' | 'primary';
};

const Tag = ({ children, icon, onClick, variant }: ComponentTypes) => {
  return (
    <Box onClick={onClick} className={`${styles.tag} ${styles[variant]}`}>
      {icon}
      {children}
    </Box>
  );
};

export default Tag;
